import axios from 'axios';
import { SignedUrlResponse } from 'src/models/signedUrlResponse';
import APIS from '../apiUrl';
import { requireAuthToken } from '../auth/getAuthToken';

const getFirmwareSignedUrl = async (
  token: string,
  firmwareId: string,
  controllerId?: string,
): Promise<SignedUrlResponse> => {
  const getSignedUrlResult = await axios.post<SignedUrlResponse>(
    `${APIS.SENTINEL_API}/api/firmware/getSignedDownloadUrl`,
    {
      firmwareId,
      controllerId,
      s3: {
        actionType: 'getObject',
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return getSignedUrlResult.data;
};

/**
 * For the provided firmware id, downloads the raw firmware binary.
 * @param firmwareId The id of the firmware (in the sentinel system) to download.
 * @param controllerId The unique identifier of the controller the firmware is being fetched for.
 * @returns The firmware binary as a uint8array.
 */
export const getFirmwareFile = async (firmwareId: string, controllerId?: string): Promise<Uint8Array> => {
  const token = await requireAuthToken();

  const signedUrl = await getFirmwareSignedUrl(token, firmwareId, controllerId);
  const file = await axios({
    method: 'GET',
    url: signedUrl.signedRequest,
    headers: { accept: 'application/octet-stream' },
    responseType: 'arraybuffer',
    responseEncoding: 'base64',
  });
  return new Uint8Array(file.data as ArrayBuffer);
};
